__turbopack_context__.v({
  "brand": "wcgw9G_brand",
  "chevron": "wcgw9G_chevron",
  "column": "wcgw9G_column",
  "copyright": "wcgw9G_copyright",
  "down": "wcgw9G_down",
  "footer": "wcgw9G_footer",
  "info": "wcgw9G_info",
  "left": "wcgw9G_left",
  "legal": "wcgw9G_legal",
  "link": "wcgw9G_link",
  "links": "wcgw9G_links",
  "name": "wcgw9G_name",
  "nav-columns": "wcgw9G_nav-columns",
  "navigation": "wcgw9G_navigation",
  "open": "wcgw9G_open",
  "reveal": "wcgw9G_reveal",
  "right": "wcgw9G_right",
  "subtitle": "wcgw9G_subtitle",
  "title": "wcgw9G_title",
  "unreveal": "wcgw9G_unreveal",
  "up": "wcgw9G_up",
});
